export const white = '#FFFFFF'
export const dodgerBlue = '#007BFF'
export const summerSky = '#3d98e5'
export const suvaGrey = '#939393'
export const solitude = '#F8F9FA'
export const nightRider = '#333333'
export const trout = '#495057'